<!-- eslint-disable vue/max-attributes-per-line -->
<template>
  <!-- 字典 -->
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="8"
                 :sm="24">
            <a-form-item label="名称编码">
              <a-input v-model="query.dictName"
                       placeholder="请输入字典名称或字典值"
                       allow-clear />
            </a-form-item>
          </a-col>
          <a-col :md="8"
                 :sm="24">
            <a-form-item label="字典值">
              <a-input v-model="query.dictValue"
                       placeholder="请输入字典值"
                       allow-clear />
            </a-form-item>
          </a-col>
          <a-col :md="8"
                 :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button type="primary"
                        @click="queryList">查询</a-button>
              <a-button style="margin-left: 8px"
                        @click="resetList">重置</a-button>
              <a-button type="primary"
                        style="margin-left: 8px"
                        @click="addOrUpdateHandle()"
                        v-action:add>新增</a-button>
              <a-button type="danger"
                        style="margin-left: 8px"
                        @click="deleteSelectRow()"
                        v-action:del>删除</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <a-table rowKey="id"
             :row-selection="{selectedRowKeys: this.selectedRows,onChange: onSelectChange }"
             :row-class-name="(_record, index) => (index % 2 === 1 ? 'table-striped' : null)"
             :data-source="list"
             :columns="columns"
             :loading="dataListLoading"
             :pagination="false">
      <span slot="action"
            slot-scope="text, record">
        <a @click="addOrUpdateHandle(record.id)"
           v-action:edit>编辑</a>
      </span>
    </a-table>
    <a-modal title="操作"
             style="top: 20px;"
             :width="800"
             v-model="addOrUpdateVisible"
             @ok="handleOk"
             @cancel="handleCancel">
      <a-form class="tenant-form"
              :form="addOrUpdateForm">
        <a-form-item :labelCol="labelCol"
                     :wrapperCol="wrapperCol"
                     label="字典名称"
                     hasFeedback>
          <a-input placeholder="字典名称"
                   v-decorator="['dictName',{ rules: [{ required: true, message: '请输入字典名称' }] }]" />
        </a-form-item>
        <a-form-item :labelCol="labelCol"
                     :wrapperCol="wrapperCol"
                     label="字典编码"
                     hasFeedback>
          <a-input :disabled="this.isUpdate"
                   placeholder="字典编码"
                   v-decorator="['dictCode',{ rules: [{ required: true, message: '请输入字典编码' }] }]" />
        </a-form-item>
        <a-form-item :labelCol="labelCol"
                     :wrapperCol="wrapperCol"
                     label="字典值">
          <a-textarea v-decorator="['dictValue',{rules: [{ required: true, message: '请输入字典值' }]}]"
                      :auto-size="{minRows: 5, maxRows: 10}">
          </a-textarea>
        </a-form-item>
        <a-form-item :labelCol="labelCol"
                     :wrapperCol="wrapperCol"
                     label="上级菜单">
          <a-tree-select v-if="list"
                         :tree-data="treeData"
                         v-decorator="['pid']"
                         style="width: 100%"
                         :replace-fields="{title: 'dictName', key: 'id', value: 'id' }"
                         :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
                         placeholder="请选择上级字典"
                         tree-default-expand-all>
          </a-tree-select>
          <a-button type="link"
                    @click="queryList"><a-icon type="reload" /></a-button>
        </a-form-item>
        <a-form-item :labelCol="labelCol"
                     :wrapperCol="wrapperCol"
                     label="排序">
          <a-input-number :formatter="limitNumber"
                          :parser="limitNumber"
                          placeholder="请输入排序"
                          v-decorator="['sort',{rules: [{type:'number',pattern:'/[^\d]/g',required: true, message: '请输入数字'}]}]" />
        </a-form-item>
      </a-form>
    </a-modal>

  </a-card>
</template>

<script>
import mixinViewModule from '@/mixin/common'
import { get1LevelDict } from '@/api/manage'
import { PERMISSION_ENUM } from '@/core/permission/permission'

const STATUS = {
  1: '正常',
  2: '禁用'
}

const columns = [
  {
    title: '字典名称',
    dataIndex: 'dictName'
  },
  {
    title: '字典编码',
    dataIndex: 'dictCode'
  },
  {
    title: '字典值',
    dataIndex: 'dictValue'
  },
  {
    title: '排序',
    dataIndex: 'sort'
  },
  {
    title: '创建时间',
    dataIndex: 'createTime'
  }, {
    title: '操作',
    width: '150px',
    dataIndex: 'action',
    scopedSlots: { customRender: 'action' }
  }
]

export default {
  mixins: [mixinViewModule],
  name: 'MenuList',
  data () {
    return {
      needPage: false,
      queryUrl: 'manager/dicts/tree',
      queryLevelUrl: 'manager/dicts/1level',
      addOrUpdateUrl: 'manager/dicts',
      queryOneUrl: 'manager/dicts',
      deleteUrl: 'manager/dicts',
      query: {
        username: '',
        status: '',
        tenantId: '',
        realName: ''
      },
      dict1LevelDataList: [],
      addOrUpdateForm: this.$form.createForm(this, { name: 'addOrUpdate' }),
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      columns
    }
  },
  filters: {
    statusFilter (key) {
      return STATUS[key]
    },
    permissionFilter (key) {
      const permission = PERMISSION_ENUM[key]
      return permission && permission.label
    }
  },
  created () {
    this.list1LevelDictData()
  },
  methods: {
    debouncedGetAnswer () {
      // this.treeData = JSON.parse(JSON.stringify(this.list))
      // this.treeData.unshift({ dictName: '上级菜单', id: '0' })
    },
    list1LevelDictData () {
      get1LevelDict().then(({ data }) => {
        this.dict1LevelDataList = data
      })
    }
  },
  computed: {
    treeData () {
      return [{
        id: '0',
        dictName: '一级字典',
        children: this.dict1LevelDataList
      }]
    }
  },
  watch: {
    //  list: function (newQuestion, oldQuestion) {
    //      this.debouncedGetAnswer()
    // }
  }
}
</script>

<style lang="less" scoped>
/deep/.table-striped {
  background-color: #fafafa;
}
.tenant-form {
  /deep/ .permission-group {
    margin-top: 0;
    margin-bottom: 0;
  }
}
</style>
